<template>
	<div id="app">
		<comHeader v-if="$route.meta.loginPage!=true"></comHeader>
		<router-view v-wechat-title="$route.meta.title" />
		<comFooter></comFooter>
	</div>
</template>

<script>
	import comHeader from "@/components/comHtml/comHeader"
	import comFooter from "@/components/comHtml/comFooter"
	export default {
		name: 'App',
		data() {
			return {
				user: {}
			}
		},
		created: function() {
			this.user = this.getLocalUser
		},
		methods: {
			

		},
		components: {
			comHeader,
			comFooter
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/App.vue